// Where a pop-up menu opens, in viewport pixels (position: fixed), next to the button that opens it: below the
// button and right-aligned with it, or above it when there is no room below but there is above; always kept
// inside the viewport with a small margin.
// button: {top, bottom, left, right} (getBoundingClientRect); menu: {width, height}; viewport: {width, height}
export const MENU_MARGIN = 8;
export const MENU_GAP = 2;

export function menuPosition(button, menu, viewport) {
	const below = viewport.height - button.bottom - MENU_GAP - MENU_MARGIN;
	const above = button.top - MENU_GAP - MENU_MARGIN;
	const up = menu.height > below && above > below;
	let top = up ? button.top - MENU_GAP - menu.height : button.bottom + MENU_GAP;
	top = Math.max(MENU_MARGIN, Math.min(top, viewport.height - MENU_MARGIN - menu.height));
	let left = button.right - menu.width;
	left = Math.max(MENU_MARGIN, Math.min(left, viewport.width - MENU_MARGIN - menu.width));
	return { top: Math.round(top), left: Math.round(left), up };
}
